/**
 * @file first-run.ts
 * @description Подсказка новичку «Как собрать страницу за 5 минут»
 * (phase19.16 Р2; uiux-design-r2 §9): ключи памяти на устройстве и шаги,
 * которые отмечаются сами по странице.
 */

import type { SitePageDetail } from "../api-site-pages";
import { isSectionBlock } from "../../components/site-pages/block-meta";

export const GUIDE_HIDDEN_KEY = "commora.builder.guide-hidden";
/** Отметка «правил текст на канве» (ставит `useBlockActions.canvasEdit`). */
export const GUIDE_CANVAS_TEXT_KEY = "commora.builder.canvas-text";

export const readFlag = (key: string): boolean => {
  try {
    return localStorage.getItem(key) === "1";
  } catch {
    return false;
  }
};
export const writeFlag = (key: string, on: boolean): void => {
  try {
    if (on) localStorage.setItem(key, "1");
    else localStorage.removeItem(key);
  } catch {
    // Подсказка — удобство; без памяти просто покажется снова.
  }
};

/** Шаги и признак «сделано» по странице. */
export function guideSteps(page: SitePageDetail, canvasText: boolean): Array<{ label: string; done: boolean }> {
  const sections = page.blocks.filter((b) => isSectionBlock(b));
  return [
    { label: "Добавьте первый экран — «Добавить блок»", done: sections.length > 0 },
    { label: "Поменяйте тексты прямо на сайте слева", done: canvasText },
    { label: "Поставьте свои фото из медиатеки", done: sections.some((b) => (b.mediaIds?.length ?? 0) > 0) },
    { label: "Добавьте ещё блоки — товары, отзывы, призыв", done: page.blocks.length >= 3 },
    { label: "Покажите страницу на сайте", done: page.isPublished },
  ];
}

